import Main from "./components/Main";

function Details() {
    return <Main/>
};

export default Details